import React from "react";
import styled from "@emotion/styled";
import { LinearProgress, Typography, Box } from "@mui/material";
import { ReactComponent as LogoImage } from "../vendor/logo.svg";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #fff;
`;

const Brand = styled(LogoImage)`
  fill: #6371F7;
  width: 264px;
  height: 64px;
  margin-bottom: 48px;
`;

const ProgressContainer = styled(Box)`
  width: 280px;
  margin-top: 24px;
`;

const StyledLinearProgress = styled(LinearProgress)`
  height: 6px;
  border-radius: 3px;
  background-color: #E8EAFC;
  & .MuiLinearProgress-bar {
    background-color: #6371F7;
    border-radius: 3px;
  }
`;

function Loader() {
  return (
    <Wrapper>
      <Brand />
      <Typography
        sx={{
          fontSize: '18px',
          fontWeight: 400,
          color: '#1a1a2e',
        }}
      >
        Loading...
      </Typography>
      <ProgressContainer>
        <StyledLinearProgress />
      </ProgressContainer>
    </Wrapper>
  );
}

export default Loader;
